export default __webpack_public_path__ + "static/media/img4.8268f44f.png";